import i18n from '../../../../../../i18n';

export const buildMessage = (label: TopologyLimitsDisplayLabels): string => {
  return i18n
    .t('topologies.topologyLimitsToolbar.modal.message')
    .replace(':label', label);
};
